export * from './muvicard.page'
